import apiClient from './client'

interface ConfirmResult {
  success: boolean
  reason?: string | null
}

export const subscribersApi = {
  /**
   * Subscribe with an email address (and optional name).
   * Always returns 202 — success message regardless of whether
   * the email already existed (no enumeration).
   */
  async subscribe(email: string, name?: string): Promise<{ message: string }> {
    const res = await apiClient.post<{ data: { message: string } }>(
      '/api/subscribers',
      { email, name: name || undefined },
    )
    return res.data.data
  },

  /**
   * Confirm a subscription using the token from the confirmation email.
   * Returns { success: true } on success, { success: false, reason } on failure.
   */
  async confirm(token: string): Promise<ConfirmResult> {
    const res = await apiClient.get<ConfirmResult>(
      `/api/subscribers/confirm/${encodeURIComponent(token)}`,
    )
    return res.data
  },

  /**
   * Unsubscribe using the token from an email footer link.
   * Returns { success: true } on success, { success: false, reason } on failure.
   */
  async unsubscribe(token: string): Promise<ConfirmResult> {
    const res = await apiClient.get<ConfirmResult>(
      `/api/subscribers/unsubscribe/${encodeURIComponent(token)}`,
    )
    return res.data
  },
}
